(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest('.af-cart-continue');
    if (!button) return;
    const opener = document.querySelector('drawer-opener[data-drawer-id="cart-drawer"]');
    if (!opener) return;
    event.preventDefault();
    event.stopPropagation();
    opener.closeDrawer();
    document.querySelector('[data-drawer-to-open="cart-drawer"]')?.focus();
  }, true);
  const note = document.getElementById('Farm-cart-note');
  if (!note) return;
  const error = document.getElementById('Farm-note-error');
  let saved = note.value;
  let pending;
  let submitting = false;
  let bypass = false;
  async function save() {
    if (pending) return pending;
    pending = (async () => {
      while (saved !== note.value) {
        const value = note.value;
        const response = await fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: value })
        });
        if (!response.ok) throw new Error('Note save failed');
        const cart = await response.json();
        if ((cart.note || '') !== value) throw new Error('Note save failed');
        saved = value;
      }
      error.hidden = true;
    })();
    try { await pending; } finally { pending = undefined; }
  }
  note.addEventListener('input', () => save().catch(() => { error.hidden = false; }));
  document.addEventListener('submit', async event => {
    if (event.target.id !== 'cart' || event.submitter?.name !== 'checkout' || bypass) return;
    event.preventDefault();
    if (submitting) return;
    submitting = true;
    const form = event.target;
    const button = event.submitter;
    button.setAttribute('aria-busy', 'true');
    try {
      await save();
      if (saved !== note.value) await save();
      // Resume in a new task after the original submit event has finished.
      // Browsers ignore requestSubmit while a submission is already being dispatched.
      await new Promise(resolve => setTimeout(resolve, 0));
      bypass = true;
      form.requestSubmit(button);
    } catch {
      error.hidden = false;
      note.focus();
    } finally {
      bypass = false;
      submitting = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
